import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'app-about-section',
  templateUrl: './about-section.component.html',
  styleUrls: ['./about-section.component.scss']
})
export class AboutSectionComponent implements AfterViewInit, OnDestroy {
  @ViewChild('imageSlider') imageSlider!: ElementRef<HTMLDivElement>;

  private observer!: IntersectionObserver;
  private intervalId: any;
  private currentIndex = 0;

  ngAfterViewInit(): void {
    // IntersectionObserver: figyeli, mikor látható a szekció
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startImageRotation();
        } else {
          this.stopImageRotation();
        }
      });
    }, { threshold: 0.4 });

    if (this.imageSlider?.nativeElement) {
      this.observer.observe(this.imageSlider.nativeElement);
    }
  }

  private startImageRotation(): void {
    const images = this.imageSlider.nativeElement.querySelectorAll('img');
    if (images.length === 0) return;

    // biztosan csak egyszer fut
    this.stopImageRotation();
    this.currentIndex = 0;

    images.forEach(img => img.classList.remove('active'));
    images[this.currentIndex].classList.add('active');

    this.intervalId = setInterval(() => {
      images[this.currentIndex].classList.remove('active');
      this.currentIndex = (this.currentIndex + 1) % images.length;
      images[this.currentIndex].classList.add('active');
    }, 2500);
  }

  private stopImageRotation(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.stopImageRotation();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
